// The layers are mutually exclusive — only one shows at a time (`layerStore. setVisible` solos on
// check) — so their controls read as radios: a hollow ring that fills with the accent when
// selected.
export const LAYER_RADIO_CLASS =
  "h-3 w-3 shrink-0 cursor-pointer appearance-none rounded-full border border-muted transition-colors checked:border-accent checked:bg-accent disabled:cursor-default disabled:opacity-50";
